import * as React from 'react'
import { useUserStore } from '~/app/_store/user-store'
import { server_setLastChangelogSeen } from './server'

export const useSetLastChangelogSeen = () => {
  const user = useUserStore((s) => (s.isSyncing ? null : s.optimisticUser))

  const setLastChangelogSeen = React.useCallback(
    (entryId: string) => {
      if (!user?.id) return
      localStorage.setItem('changelog-seen', entryId)
      server_setLastChangelogSeen({ userId: user.id, entryId })
    },
    [user]
  )

  return setLastChangelogSeen
}
